class ComparisonSliderComponent extends HTMLElement {
  constructor() {
    super();
    this.hasAnimated = false;
    this.isAnimating = false;
    this.timeoutIds = [];
    this.handleIntersection = this.handleIntersection.bind(this);
    this.sync = this.sync.bind(this);
  }

  connectedCallback() {
    this.mediaWrapper = this.querySelector('[data-comparison-slider]');
    this.slider = this.querySelector('.cs-slider');

    if (!this.mediaWrapper || !this.slider) {
      return;
    }

    this.slider.addEventListener('input', this.sync);
    this.slider.addEventListener('pointerdown', this.sync);

    this.sync();
    this.setupIntersectionObserver();
  }

  disconnectedCallback() {
    if (this.slider) {
      this.slider.removeEventListener('input', this.sync);
      this.slider.removeEventListener('pointerdown', this.sync);
    }

    if (this.intersectionObserver) {
      this.intersectionObserver.disconnect();
    }

    this.timeoutIds.forEach((id) => clearTimeout(id));
    this.timeoutIds = [];
  }

  sync() {
    if (!this.mediaWrapper || !this.slider || this.isAnimating) {
      return;
    }

    const value = Number(this.slider.value);
    const min = Number(this.slider.min);
    const max = Number(this.slider.max);
    const percentage = Math.round(((value - min) / (max - min)) * 100);

    this.mediaWrapper.style.setProperty('--compare', String(percentage));
  }

  setupIntersectionObserver() {
    if (!window.IntersectionObserver) {
      return;
    }

    this.intersectionObserver = new IntersectionObserver(this.handleIntersection, {
      root: null,
      rootMargin: '0px',
      threshold: 0.5,
    });

    this.intersectionObserver.observe(this);
  }

  handleIntersection(entries) {
    entries.forEach((entry) => {
      if (!entry.isIntersecting || this.hasAnimated) {
        return;
      }

      const canAnimate = this.reserveEditorAnimationSlot();
      if (!canAnimate) {
        return;
      }

      const delayId = setTimeout(() => {
        this.animateSlider();
      }, 300);
      this.timeoutIds.push(delayId);

      if (this.intersectionObserver) {
        this.intersectionObserver.disconnect();
      }
    });
  }

  reserveEditorAnimationSlot() {
    if (!window.Shopify || !window.Shopify.designMode) {
      return true;
    }

    try {
      const key = 'comparison-slider-animated';
      if (sessionStorage.getItem(key)) {
        return false;
      }
      sessionStorage.setItem(key, '1');
      return true;
    } catch (_error) {
      return true;
    }
  }

  animateSlider() {
    if (!this.mediaWrapper || !this.slider || this.hasAnimated) {
      return;
    }

    this.hasAnimated = true;
    this.isAnimating = true;

    this.mediaWrapper.style.setProperty('--transition-duration', '0.5s');

    this.timeoutIds.push(
      setTimeout(() => {
        this.mediaWrapper.style.setProperty('--compare', '40');
      }, 100)
    );

    this.timeoutIds.push(
      setTimeout(() => {
        this.mediaWrapper.style.setProperty('--compare', '60');
      }, 600)
    );

    this.timeoutIds.push(
      setTimeout(() => {
        this.mediaWrapper.style.setProperty('--compare', '50');
      }, 1100)
    );

    this.timeoutIds.push(
      setTimeout(() => {
        this.mediaWrapper.style.setProperty('--transition-duration', '0s');
        this.slider.value = '50';
        this.isAnimating = false;
      }, 1600)
    );
  }
}

if (!customElements.get('comparison-slider-component')) {
  customElements.define('comparison-slider-component', ComparisonSliderComponent);
}
